export default {
  1: 'Отлично',
  2: 'Нормально',
  3: 'Плохо',
}
